import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import MetisMenu from 'metismenujs/dist/metismenujs';
import { Router, NavigationEnd } from '@angular/router';

import { EventService } from '../../../core/services/event.service';

import { MenuItem } from './menu.model';
import { AuthfakeauthenticationService } from '../../../core/services/authfake.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit, AfterViewInit {

  menu: any;
  user: any;

  menuItems = [];

  @ViewChild('sideMenu') sideMenu: ElementRef;

  constructor(
    private eventService: EventService,
    private router: Router,
    private authFackservice: AuthfakeauthenticationService,
  ) {
    router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        this._activateMenuDropdown();
      }
    });
  }

  ngOnInit(): void {
    this.user = this.authFackservice.currentUserValue;
    this.initialize();
  }

  ngAfterViewInit() {
    this.menu = new MetisMenu(this.sideMenu.nativeElement);

    this._activateMenuDropdown();
  }

  /**
   * remove active and mm-active class
   */
  _removeAllClass(className) {
    const els = document.getElementsByClassName(className);
    while (els[0]) {
      els[0].classList.remove(className);
    }
  }

  /**
   * Activate the parent dropdown
   */
  _activateMenuDropdown() {
    this._removeAllClass('mm-active');
    this._removeAllClass('mm-show');
    const links = document.getElementsByClassName('side-nav-link-ref');
    let menuItemEl = null;

    const paths = [];
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < links.length; i++) {
      // tslint:disable-next-line: no-string-literal
      paths.push(links[i]['pathname']);
    }
    const itemIndex = paths.indexOf(window.location.pathname);
    if (itemIndex === -1) {
      const strIndex = window.location.pathname.lastIndexOf('/');
      const item = window.location.pathname.substr(0, strIndex).toString();
      menuItemEl = links[paths.indexOf(item)];
    } else {
      menuItemEl = links[itemIndex];
    }

    if (menuItemEl) {
      menuItemEl.classList.add('active');
      const parentEl = menuItemEl.parentElement;

      if (parentEl) {
        parentEl.classList.add('mm-active');

        const parent2El = parentEl.parentElement.closest('ul');
        if (parent2El && parent2El.id !== 'side-menu') {
          parent2El.classList.add('mm-show');
          const parent3El = parent2El.parentElement;

          if (parent3El && parent3El.id !== 'side-menu') {
            parent3El.classList.add('mm-active');
            const childAnchor = parent3El.querySelector('.has-arrow');
            const childDropdown = parent3El.querySelector('.has-dropdown');

            if (childAnchor) { childAnchor.classList.add('mm-active'); }
            if (childDropdown) { childDropdown.classList.add('mm-active'); }

            const parent4El = parent3El.parentElement;
            if (parent4El && parent4El.id !== 'side-menu') {
              parent4El.classList.add('mm-show');
              const parent5El = parent4El.parentElement;
              if (parent5El && parent5El.id !== 'side-menu') {
                parent5El.classList.add('mm-active');
                const childanchor = parent5El.querySelector('.is-parent');
                if (childanchor && parent5El.id !== 'side-menu') { childanchor.classList.add('mm-active'); }
              }
            }
          }
        }
      }
    }
  }

  /**
   * Initialize
   */
  initialize(): void {
    let MENU: MenuItem[] = [];
    if (this.user.type === 'customer') {
      MENU = [
        {
          label: 'MENUITEMS.MENU.TEXT',
          isTitle: true
        },
        {
          label: 'MENUITEMS.DASHBOARDS.TEXT',
          icon: 'ri-dashboard-line',
          link: '/'
        },
        {
          label: 'MENUITEMS.PROJECT.TEXT',
          icon: 'ri-folder-shield-line',
          link: '/projets'
        },
        {
          label: 'MENUITEMS.USERS.TEXT',
          icon: 'ri-folder-user-line',
          link: '/utilisateurs'
        },
        {
          label: 'MENUITEMS.QUIZ.TEXT',
          icon: 'ri-survey-line',
          link: '/questionnaire'
        },
        {
          label: 'MENUITEMS.COUPONS.TEXT',
          icon: 'ri-coupon-line',
          link: '/coupons'
        },
        {
          label: 'MENUITEMS.INTEGRATION.TEXT',
          icon: 'ri-computer-line',
          link: '/integration'
        },
        {
          label: 'MENUITEMS.ACCOUNT.TEXT',
          icon: 'ri-account-box-line',
          link: '/informations-personnelles'
        },
      ];
    }

    if (this.user.type === 'designer') {
      MENU = [
        {
          label: 'MENUITEMS.MENU.TEXT',
          isTitle: true
        },
        {
          label: 'MENUITEMS.DASHBOARDS.TEXT',
          icon: 'ri-dashboard-line',
          link: '/'
        },
        {
          label: 'MENUITEMS.PROJECT.TEXT',
          icon: 'ri-folder-shield-line',
          link: '/projets'
        },
        {
          label: 'MENUITEMS.ACCOUNT.TEXT',
          icon: 'ri-account-box-line',
          link: '/informations-personnelles'
        },
      ];
    }

    if (this.user.type === 'admin') {
      MENU = [
        {
          label: 'MENUITEMS.MENU.TEXT',
          isTitle: true
        },
        {
          label: 'MENUITEMS.DASHBOARDS.TEXT',
          icon: 'ri-dashboard-line',
          link: '/'
        },
        {
          label: 'MENUITEMS.PROJECT.TEXT',
          icon: 'ri-folder-shield-line',
          link: '/projets'
        },
        {
          label: 'MENUITEMS.USERS.TEXT',
          icon: 'ri-folder-user-line',
          link: '/utilisateurs'
        },
        {
          label: 'MENUITEMS.DESIGNERS.TEXT',
          icon: 'ri-pencil-ruler-2-line',
          link: '/designers'
        },
        {
          label: 'MENUITEMS.COUPONS.TEXT',
          icon: 'ri-coupon-line',
          link: '/coupons'
        },
        {
          label: 'MENUITEMS.QUIZ.TEXT',
          icon: 'ri-coupon-line',
          link: '/questionnaire/copie'
        },
      ];
    }
    this.menuItems = MENU;
  }

  /**
   * Returns true or false if given menu item has child or not
   * @param item menuItem
   */
  hasItems(item: MenuItem) {
    return item.subItems !== undefined ? item.subItems.length > 0 : false;
  }

  /**
   * Change the layout onclick
   * @param layout Change the layout
   */
  changeLayout(layout: string) {
    this.eventService.broadcast('changeLayout', layout);
  }

  /**
   * Light sidebar
   */
  lightSidebar() {
    document.body.setAttribute('data-sidebar', 'light');
    document.body.setAttribute('data-topbar', 'dark');
    document.body.removeAttribute('data-sidebar-size');
    document.body.removeAttribute('data-layout-size');
    document.body.removeAttribute('data-keep-enlarged');
    document.body.classList.remove('vertical-collpsed');
  }

  /**
   * Compact sidebar
   */
  compactSidebar() {
    document.body.setAttribute('data-sidebar-size', 'small');
    document.body.setAttribute('data-sidebar', 'dark');
    document.body.removeAttribute('data-topbar');
    document.body.removeAttribute('data-layout-size');
    document.body.removeAttribute('data-keep-enlarged');
    document.body.classList.remove('sidebar-enable');
    document.body.classList.remove('vertical-collpsed');
  }

  /**
   * Icon sidebar
   */
  iconSidebar() {
    document.body.classList.add('sidebar-enable');
    document.body.classList.add('vertical-collpsed');
    document.body.setAttribute('data-sidebar', 'dark');
    document.body.removeAttribute('data-layout-size');
    document.body.removeAttribute('data-keep-enlarged');
    document.body.removeAttribute('data-topbar');
  }

  /**
   * Boxed layout
   */
  boxedLayout() {
    document.body.setAttribute('data-keep-enlarged', 'true');
    document.body.setAttribute('data-layout-size', 'boxed');
    document.body.setAttribute('data-sidebar', 'dark');
    document.body.classList.add('vertical-collpsed');
    document.body.classList.remove('sidebar-enable');
    document.body.removeAttribute('data-topbar');
  }

  /**
   * Colored sidebar
   */
  coloredSidebar() {
    document.body.setAttribute('data-sidebar', 'colored');
    document.body.removeAttribute('data-sidebar-size');
    document.body.removeAttribute('data-layout-size');
    document.body.classList.remove('vertical-collpsed');
    document.body.removeAttribute('data-topbar');
  }

}
